module.exports = __webpack_public_path__ + "static/media/1022723.434f9c34.jpg";